import { combineReducers } from 'redux';
import accountReducer from './account/account.reducer';
import appSettingsReducer from './appSettings/appSettings.reducer';
import controlsReducer from './controls/controls.reducer';
import explorePanelReducer from './explorePanel/explorePanel.reducer';
import ItemDetailReducer from './itemDetail/itemDetail.reducer';
import queryPanelReducer from './queryPanel/queryPanel.reducer';
import queryResultsReducer from './queryResults/queryResults.reducer';
import rostersReducer from './rosters/rosters.reducer';
import switchViewReducer from './switchView/switchView.reducer';

/**
 * Composite of all reducers within the application. Add individual reducers here.
 */
const rootReducer = combineReducers({
  account: accountReducer,
  appSettings: appSettingsReducer,
  controls: controlsReducer,
  explorePanel: explorePanelReducer,
  itemDetail: ItemDetailReducer,
  queryPanel: queryPanelReducer,
  queryResults: queryResultsReducer,
  rosters: rostersReducer,
  switchView: switchViewReducer,
});

export default rootReducer;